import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SelectBestOffer from './SelectBestOffer';
import { getBestOffers, setBestOffer } from './selectBestOfferActions';

function SelectBestOfferContainer(props) {
    return (
        <SelectBestOffer
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            isPending={props.isPending}
            bestOffers={props.bestOffers}
            selectedOffer={props.selectedOffer}
            setBestOffer={props.setBestOffer}
        />
    );
}

const mapStateToProps = state => ({
    bestOffers: state.selectBestOfferReducer.bestOffers,
    selectedOffer: state.selectBestOfferReducer.selectedOffer,
    isPending: state.selectBestOfferReducer.isPending,
});

const mapDispatchToProps = dispatch => ({
    getBestOffers: (event) => {
        dispatch(getBestOffers(event));
    },
    setBestOffer: (event) => {
        dispatch(setBestOffer(event));
    },
});

SelectBestOfferContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    isPending: PropTypes.bool.isRequired,
    bestOffers: PropTypes.array.isRequired,
    selectedOffer: PropTypes.number.isRequired,
    setBestOffer: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectBestOfferContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SelectBestOffer/SelectBestOfferContainer.js